import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const DrawerContext = createContext();

export function DrawerProvider({ children }) {
    const [activeDrawerId, setActiveDrawerId] = useState(null);
    const [drawerData, setDrawerData] = useState({});
    const callbacksRef = useRef({});

    const openDrawer = useCallback((drawerId, data = {}) => {
        const { onSuccess, ...renderData } = data;
        callbacksRef.current = { onSuccess };
        setDrawerData(renderData);
        setActiveDrawerId(drawerId);
    }, []);

    const updateDrawerData = useCallback((data) => {
        setDrawerData((prev) => ({ ...prev, ...data }));
    }, []);

    const closeDrawer = useCallback(() => {
        setActiveDrawerId(null);
        setDrawerData({});
        callbacksRef.current = {};
    }, []);

    const getCallbacks = useCallback(() => callbacksRef.current, []);

    return (
        <DrawerContext.Provider value={{ activeDrawerId, openDrawer, closeDrawer, updateDrawerData, drawerData, getCallbacks }}>
            {children}
        </DrawerContext.Provider>
    );
}

export function useDrawer() {
    return useContext(DrawerContext);
}
